import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import moment from 'moment';

import { setPropertyAccessDetails } from '../../reducers/tenant-job-entry';
import { createWorkOrder } from '../../services/services';

const useSubmitCreateWO = ({ errorCallback }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const tenantEntryDetails = useSelector((state) => state.tenantJobEntry);

  const onSubmit = (formData = {}) => {
    setIsFormSubmitting(true);
    const propertyAccessData = {
      ...(formData || {}),
      specificAccessNote: formData?.specificAccessNote || '',
    };
    dispatch(setPropertyAccessDetails(propertyAccessData));

    const jobSchedules = Object.keys(tenantEntryDetails?.job_schedules || {})
      .reduce((acc, key) => {
        const data = tenantEntryDetails?.job_schedules?.[key];

        if (!isEmpty(data)) {
          acc.push({
            ...data,
            date: data?.date ? moment(data?.date).format('YYYY-MM-DD') : '',
            timings: data?.timings?.filter((time) => time !== 'anytime'),
          });
        }

        return acc;
      }, []);

    const jobMedias = tenantEntryDetails?.job_medias?.map(
      (item) => item?.job_media_id,
    );
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const payload = {
      is_emergency: tenantEntryDetails?.is_emergency ? 'yes' : 'no',
      specific_access_notes: formData?.specificAccessNote || '',
      door_code: formData?.doorCode,
      how_to_access: formData?.propertyAccess,
      description: tenantEntryDetails?.description,
      service_category: tenantEntryDetails?.service_category?.slug,
      zip_code: tenantEntryDetails?.residentInfo?.zip_code,
      job_media_ids: jobMedias,
      job_schedules: !tenantEntryDetails?.is_emergency ? jobSchedules : [],
      timezone,
    };

    createWorkOrder(payload).then(() => {
      setIsFormSubmitting(false);
      navigate('/success');
    }).catch((err) => {
      setIsFormSubmitting(false);
      if (errorCallback) {
        errorCallback(err);
      }
    });
  };

  return { onSubmit, isFormSubmitting, setIsFormSubmitting };
};

export default useSubmitCreateWO;
